﻿import {UISprite} from "./Tools/Base/UISprite";
import {Core} from "../Base/Core";
import {gsap} from "gsap";

class TutorialHand extends UISprite {

    constructor() {
        super();
        this.dragHelper = this.addChild(new UISprite("creatures/1")); // XXX: hardcoded helper
        this.dragHelper.scale.set(0.3);
        this.dragHelper.alpha = 0.5;
        this.dragHelper.visible = false;
        this.img = this.addChild(new UISprite("hand2"));
        this.img.anchor.set(0, 0);
        this.animation = null;
        this.on("added", () => this.fitLayout());
    }

    fitLayout(viewport = Core.app.viewport) {
        requestAnimationFrame(() => {
            let s = Core.app.renderer.resolution;
            if (this.parent) {
                s = 1 / this.parent.worldTransform.a;
            }
            this.scale.set(viewport.width * 0.05 * s / this.img.texture.width);
        });
    }

    ClearAnimation() {
        if (this.animation) this.animation.kill();
        this.animation = null;
        this.dragHelper.visible = false;
    }

    Pulse() {
        if (this.animation && this.animation.vars.name === "pulse") return;
        this.ClearAnimation();
        this.animation = gsap.timeline({name: "pulse", repeat: -1, repeatDelay: 0.2})
            .set(this.img, {pixi: {scale: 1}})
            .to(this.img, {pixi: {scale: 1.2}, duration: 1})
            .to(this.img, {pixi: {scale: 1}, duration: 1})
    }

    FromTo(from, to) {
        if (this.animation && this.animation.vars.name === "from-to") return;
        return new Promise(resolve => {
            this.ClearAnimation();
            this.position.copyFrom(from);
            this.dragHelper.visible = true;
            this.animation = gsap.timeline({name: "from-to"})
                .set(this.dragHelper, {alpha: 0, pixi: {scale: 0}}, 0)
                .set(this, {x: from.x, y: from.y}, 0)
                .to(this.dragHelper, {alpha: 0.7, pixi: {scale: 2}, duration: 0.3}, 0)
                .to(this.dragHelper, {alpha: 0.7, pixi: {scale: 3}, duration: 0.5}, 0.3)
                .to(this, {x: to.x, y: to.y, duration: 1})
                .to(this.dragHelper, {alpha: 0, pixi: {scale: 0}, duration: 0.3})
                .eventCallback("onComplete", () => {
                    this.ClearAnimation();
                    resolve();
                })
            ;
        });
    }

    SetActive(active) {
        let changed = this.Active ^ active;
        super.SetActive(active);
        if (active) {
            gsap.to(this, {alpha: 1, duration: 1});
        } else {
            if (changed) this.ClearAnimation();
            this.alpha = 0;
            this.dragHelper.visible = false;
        }
        this.fitLayout();
    }
}

export class TutorialPanel extends UISprite {

    isShowingSomething = false;
    activeObject = null;

    Awake() {
        super.Awake();
        this.hand = this.addChild(new TutorialHand());
        this.SetHandActive(false);
    }

    fitLayout(viewport = Core.app.viewport) {
        this.hand.fitLayout(viewport);
    }

    HandToPointPulse(position, parent = this.activeObject || this) {
        if (this.isShowingSomething) return;
        this.isShowingSomething = true;
        this.SetHandActive(true, parent);
        this.hand.position.copyFrom(position);
        this.hand.Pulse();
    }

    async HandPointToFrom(from, to, parent = this) {
        if (this.isShowingSomething) return;
        this.isShowingSomething = true;
        this.SetHandActive(true, parent);
        this.hand.position.copyFrom(from);
        await this.hand.FromTo(from, to);
        this.SetHandActive(false);
    }

    SetHandActive(active, parent = this.activeObject || this) {
        if (this.hand.parent) {
            this.hand.parent.removeChild(this.hand);
        }
        if (!active) {
            this.activeObject = null;
            this.isShowingSomething = false;
        }
        else {
            parent.addChild(this.hand);
        }
        this.hand.SetActive(active);
        this.fitLayout();
    }

    UpdateObjectHand() {
        if (!this.activeObject || !this.activeObject.parent || !this.hand.parent) return;
        let b = this.activeObject.getLocalBounds();
        let p = this.hand.parent.toLocal(new PIXI.Point(b.x + b.width * 0.5, b.y + b.height * 0.5), this.activeObject);
        this.hand.position.copyFrom(p);
    }

    ShowObjectHand(obj, parent = obj && obj.parent || obj) {
        if (this.activeObject === obj) return this.fitLayout();
        this.SetHandActive(false);

        this.activeObject = obj;
        if (this.activeObject) {
            let b = obj.getLocalBounds();
            let p = parent.toLocal(new PIXI.Point(b.x + b.width * 0.5, b.y + b.height * 0.5), obj);
            this.HandToPointPulse(p, parent);
        }
    }

    HideObjectHand(obj = null) {
        if (!obj || this.activeObject === obj) {
            this.activeObject = null;
            this.SetHandActive(false);
        }
    }
}

